module.exports = __webpack_public_path__ + "static/02@2x-e441b32ea64f2550494b34519d48da0c.png";